import type { Technique } from '../types';
import { FLOW_FIELD_PARAMS } from './params';
import { draw, elementCount, init, isComplete, step, type FlowFieldState } from './render';

export const flowField: Technique<FlowFieldState> = {
  id: 'flow-field',
  name: 'Flow Field',
  category: 'field',
  description: 'Partikel folgen einem Rauschfeld und ziehen Stromlinien; der Text lenkt sie ab.',
  params: FLOW_FIELD_PARAMS,
  renderer: 'canvas2d',
  isAnimated: false,
  init,
  step,
  isComplete,
  draw,
  elementCount,
};
